import { c as _c } from "react/compiler-runtime";
import { useIsVisible } from "@website/hooks/is-visible";
import { numberConvert } from "@website/utils/number-convert";
import { Mapbox } from "@website/widget/mapbox";
import { ReserveMapPropertiesTypes } from "@website/widget/reserve-map/reserve-map.types";
import omit from "lodash-es/omit";
import { useRouter } from "next/router";
export const ReserveMap = properties => {
  const $ = _c(19);
  const router = useRouter();
  const {
    sectionTitle,
    title,
    type,
    showDescription: t0
  } = properties;
  const showDescription = t0 === undefined ? true : t0;
  const {
    reference,
    inView
  } = useIsVisible();
  const isVilla = process.env.NEXT_PUBLIC_APP_NAME === "villa";
  const coords = isVilla ? properties?.circle : properties?.marker;
  if (!coords?.lat || !coords?.lng || coords.lat === 35.696814 && coords.lng === 51.3498186) {
    return null;
  }
  let t1;
  if ($[0] !== router || $[1] !== sectionTitle || $[2] !== title) {
    t1 = (sectionTitle || title) && <h2 className="text-subtitle-1 md:text-headline-6 pb-1 md:pb-4">{sectionTitle ?? `موقعیت های مکانی و دسترسی های ${numberConvert(title ?? "", {
        locale: router.locale
      })}`}</h2>;
    $[0] = router;
    $[1] = sectionTitle;
    $[2] = title;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== showDescription || $[5] !== type) {
    t2 = showDescription && <div className="text-caption text-on-surface-medium-emphasis">{isVilla ? "\u0622\u062F\u0631\u0633 \u062F\u0642\u06CC\u0642 \u0628\u0639\u062F \u0627\u0632 \u062B\u0628\u062A \u0631\u0632\u0631\u0648 \u0628\u0631\u0627\u06CC \u0634\u0645\u0627 \u067E\u06CC\u0627\u0645\u06A9 \u062E\u0648\u0627\u0647\u062F \u0634\u062F." : `مراکز نزدیک به ${type} را میتوانید از روی نقشه مشاهده کنید.`}</div>;
    $[4] = showDescription;
    $[5] = type;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = <div className="py-4">{t1}{t2}</div>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== inView || $[11] !== properties) {
    t4 = inView ? <Mapbox {...omit(properties, ["sectionTitle", "title", "type"])} /> : false;
    $[10] = inView;
    $[11] = properties;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== reference || $[14] !== t4) {
    t5 = <div className="relative h-[312px] overflow-hidden bg-gray-100 md:h-[360px] xl:h-[468px] xl:rounded-2xl" ref={reference}>{t4}</div>;
    $[13] = reference;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t3 || $[17] !== t5) {
    t6 = <div id="hotel_location">{t3}{t5}</div>;
    $[16] = t3;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
};